import { combineReducers, createSlice } from '@reduxjs/toolkit'
import { CollateralSearchParams, HypothecCollateral } from '@lk/api'

import { ActionPayload } from '../index.d'
import {
  loadHypothecCollaterals,
  resetHypothecCollaterals,
  destroyCollateralsSearch,
  collateralSearchAgain,
} from './collateral.actions'

export interface HypothecCollateralState {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  data: HypothecCollateral[]
  instance: {
    [key: string]: {
      data: HypothecCollateral[]
      searchParams: CollateralSearchParams
    }
  }
  error: null | string
}

const initialHypothecCollateralState: HypothecCollateralState = {
  status: 'idle',
  data: [],
  instance: {},
  error: null,
}

const hypothecCollateralsReducer = createSlice({
  name: 'hypothecCollaterals',
  initialState: initialHypothecCollateralState,
  reducers: {},
  extraReducers: {
    [loadHypothecCollaterals.pending.toString()]: (state) => {
      state.status = 'loading'
    },
    [loadHypothecCollaterals.fulfilled.toString()]: (
      state,
      action: ActionPayload<
        | HypothecCollateral[]
        | {
            instanceName: string
            data: HypothecCollateral[]
          }
      >,
    ) => {
      state.status = 'loaded'
      if (Array.isArray(action.payload)) {
        state.data = action.payload
      } else {
        const obj = {
          data: action.payload.data,
          //@ts-ignore
          searchParams: action.meta.arg,
        }
        state.instance[action.payload.instanceName] = obj
      }
    },
    [loadHypothecCollaterals.rejected.toString()]: (state, action: ActionPayload<string>) => {
      state.status = 'failed'
      state.error = action.payload
    },
    [collateralSearchAgain.pending.toString()]: (state) => {
      state.status = 'loading'
    },
    [collateralSearchAgain.fulfilled.toString()]: (
      state,
      action: ActionPayload<
        | HypothecCollateral[]
        | {
            instanceName: string
            data: HypothecCollateral[]
          }
      >,
    ) => {
      state.status = 'loaded'
      if (Array.isArray(action.payload)) {
        state.data = action.payload
      } else {
        const obj = {
          data: action.payload.data,
          searchParams: state.instance[action.payload.instanceName].searchParams,
        }
        state.instance[action.payload.instanceName] = obj
      }
    },
    [collateralSearchAgain.rejected.toString()]: (state, action: ActionPayload<string>) => {
      state.status = 'failed'
      state.error = action.payload
    },
    [resetHypothecCollaterals.toString()]: (state) => {
      return {
        status: 'idle',
        data: [],
        instance: { ...state.instance },
        error: null,
      }
    },
    [destroyCollateralsSearch.toString()]: (state) => {
      return {
        ...state,
        instance: {},
      }
    },
  },
}).reducer

export const collateralReducer = combineReducers({
  hypothecCollaterals: hypothecCollateralsReducer,
})
